import React from 'react'
import CategoryContainer from '../../Components/Category/CategoryContainer'
import Pagenation from '../../Components/Utilities/Pagenation'
const AllCategory = () => {
    return (
        <div>
        <CategoryContainer/>
        <Pagenation/>
        </div>
    )
}

export default AllCategory
